/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { subnetReplicaVersionsGetApiV3SubnetReplicaVersionsReplicaVersionId } from "../../funcs/subnetReplicaVersionsGetApiV3SubnetReplicaVersionsReplicaVersionId.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetApiV3SubnetReplicaVersionsReplicaVersionIdRequest$inboundSchema,
};

export const tool$subnetReplicaVersionsGetApiV3SubnetReplicaVersionsReplicaVersionId:
  ToolDefinition<typeof args> = {
    name:
      "versions-subnet-replica-versions-replica-version-id",
    description: ``,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await subnetReplicaVersionsGetApiV3SubnetReplicaVersionsReplicaVersionId(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
